import { call, put, takeLatest } from "@redux-saga/core/effects";
import { getListLink } from "@iso/services/link";
import { notification } from "@iso/components";
import actions from "./actions";

function* fetchListLink() {
  yield put({ type: actions.SET_IS_LOADING, payload: true });
  let {errCode, errDetail, result } = yield call(getListLink);

  
  if (errCode) {
    return notification("error", errDetail);
  }
  yield put({ type: actions.SET_LIST_LINK, payload: result.data });
}

export default function* rootSaga() {
  yield takeLatest(actions.GET_LIST_LINK, fetchListLink);
}
